// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext, useEffect, Fragment } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation, Trans as T } from 'react-i18next';
import user_agent from '/util/user_agent.js';
import etask from '/util/etask.js';
import storage from '/util/storage.js';
import common_ui from '/svc/vpn/pub/common_ui.js';
import { guess_browser } from 'zuser_agent';
import { App_context } from '../../context.js';
import www_util from '../../util.js';
import { get_icon_urls } from '../../cp/util.js';
import Icon_appstore_logo from '../../img/svg/icon/appstore_logo.svg';
import Icon_playstore_logo from '../../img/svg/icon/playstore_logo.svg';
import { Svg } from '../../ui/svg';
import be from '../../be.js';
import { User_icon } from '../user_icon.tsx';
import * as ui_links from '../ui_install_links.ts';
import { Settings_context } from '../../settings_ctx';
import { Form } from '../login/form';
import { Link } from '../link.tsx';
import { use_screen } from '../../lib/screen_util.ts';
var sys = user_agent.guess();
var Store_btn = props => {
  var content_data = {
    ios: {
      first_line: 'Download on the',
      second_line: 'App Store',
      href: 'https://itunes.apple.com/us/app' + '/hola-vpn/id1553473179?mt=8',
      icon: /*#__PURE__*/React.createElement(Icon_appstore_logo, {
        width: 32,
        height: 32
      })
    },
    android: {
      first_line: 'Download apk',
      second_line: '',
      href: 'https://hola.org/download/android',
      icon: /*#__PURE__*/React.createElement(Icon_playstore_logo, {
        width: 32,
        height: 32
      })
    }
  };
  var content = content_data[sys.os];
  if (!content) return null;
  return /*#__PURE__*/React.createElement("a", {
    href: content.href,
    className: "store_btn"
  }, /*#__PURE__*/React.createElement(Svg, {
    icon: content.icon,
    cls: "store_btn-img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "store_btn-text"
  }, /*#__PURE__*/React.createElement("span", null, content.first_line), /*#__PURE__*/React.createElement("span", null, content.second_line)));
};
var User_nav = props => {
  var _useContext = useContext(App_context),
    has_ext = _useContext.has_ext,
    user = _useContext.user;
  var _useContext2 = useContext(Settings_context),
    show_modal = _useContext2.show_modal;
  var logout_url = props.logout_url,
    on_logout = props.on_logout,
    logout_redir_url = props.logout_redir_url,
    app_mode = props.app_mode,
    set_toggled = props.set_toggled,
    user_links = props.user_links;
  useTranslation();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hovered = _useState2[0],
    set_hovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menu_hidden = _useState4[0],
    set_menu_hidden = _useState4[1];
  var _useLocation = useLocation(),
    state = _useLocation.state;
  var b = guess_browser();
  var store_link = ui_links[`${b.browser}_href`] || ui_links.chrome_href;
  var show_login_modal = (signup_mode, next) => event => {
    event && event.preventDefault();
    show_modal('login_form', p => {
      return /*#__PURE__*/React.createElement(Form, _extends({}, p, {
        default_state: signup_mode ? 'signup_buttons' : 'login_buttons'
      }));
    }, {
      width: 736,
      paddingless: true
    });
    return;
  };
  var on_login_click = signup_mode => event => {
    if (user_links) return;
    if (signup_mode) {
      event.preventDefault();
      location.href = store_link;
      return;
    }
    show_login_modal(signup_mode)(event);
  };
  var _use_screen = use_screen(),
    width = _use_screen.width;
  useEffect(() => {
    if (!state) return;
    if (state.need_login) show_login_modal(false, state.next)();
    if (state.need_signup) show_login_modal(true)();
  }, [state]);
  var get_logout_url = () => logout_url || '/users/logout/inline';
  var logout = event => {
    event.preventDefault();
    etask(function* () {
      yield www_util.ajax({
        url: get_logout_url(),
        type: 'POST',
        xhrFields: {
          withCredentials: true
        }
      });
      storage.clr_all();
      be.refresh_membership();
      if (on_logout) on_logout();else location.href = logout_redir_url || '/';
    });
  };
  var on_click_menu = event => {
    if (sys.mobile) {
      event.preventDefault();
      set_hovered(!hovered);
    }
  };
  var on_click_menu_item = event => {
    set_menu_hidden(true);
    set_toggled(false);
    setTimeout(() => set_menu_hidden(false), 1000);
  };
  var on_leave_menu = () => set_hovered(false);
  var is_touch = 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  var user_status_cls = cn('user_status', is_touch && 'touch');
  var name = user && user.provider != 'basic' && (user.displayName || '').replace(/ .*$/, '') || 'Profile';
  if (user && user.provider != 'basic' && user.displayName == null) www_util.perr({
    id: 'www_debug_user',
    info: {
      user
    }
  });
  if (name.length > 12) name = name.slice(0, 9) + '...';
  var cls = cn('user_nav_container top_right', user && 'logged_in');
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    onMouseLeave: on_leave_menu
  }, user && !user_links && /*#__PURE__*/React.createElement("div", {
    className: "nav_veil"
  }), user && !user_links && /*#__PURE__*/React.createElement("ul", {
    className: user_status_cls
  }, /*#__PURE__*/React.createElement("li", {
    className: cn('dropdown', hovered && 'hovered')
  }, /*#__PURE__*/React.createElement(Link, {
    className: "dropdown-toggle",
    to: "/cp",
    onClick: on_click_menu,
    "data-clickid": "user_dropdown"
  }, /*#__PURE__*/React.createElement(User_icon, {
    user: user,
    white: true
  }), name), /*#__PURE__*/React.createElement("div", {
    className: "menu-wrapper"
  }, /*#__PURE__*/React.createElement("ul", {
    className: cn('dropdown-menu', menu_hidden && 'hidden')
  }, /*#__PURE__*/React.createElement("li", {
    className: "menu-item"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "user_link",
    to: "/cp",
    "data-clickid": "user_my_account",
    onClick: on_click_menu_item
  }, /*#__PURE__*/React.createElement(common_ui.Menu_icon, {
    id: "profile",
    img_urls: get_icon_urls('profile')
  }), /*#__PURE__*/React.createElement("span", null, "My Account"))), !app_mode && has_ext && /*#__PURE__*/React.createElement("li", {
    className: "menu-item"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "user_link",
    to: "/cp/settings",
    "data-clickid": "user_my_settings",
    onClick: on_click_menu_item
  }, /*#__PURE__*/React.createElement(common_ui.Menu_icon, {
    id: "settings",
    img_urls: get_icon_urls('settings')
  }), /*#__PURE__*/React.createElement("span", null, "My Settings"))), width < 768 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "menu-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/products",
    className: "user_link support",
    "data-clickid": "user_products",
    onClick: on_click_menu_item
  }, "Products"), /*#__PURE__*/React.createElement(Link, {
    to: "/pricing?ref=user_plans",
    className: "user_link support",
    "data-clickid": "user_plans",
    onClick: on_click_menu_item
  }, "Plans"))), /*#__PURE__*/React.createElement("li", {
    className: "menu-item"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/cp/support",
    className: "user_link",
    "data-clickid": "user_support",
    onClick: on_click_menu_item
  }, /*#__PURE__*/React.createElement(common_ui.Menu_icon, {
    id: "support",
    img_urls: get_icon_urls('support')
  }), /*#__PURE__*/React.createElement("span", null, "Support"))), /*#__PURE__*/React.createElement("li", {
    className: "menu-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: "",
    className: "user_link",
    id: "logout_lnk",
    onClick: logout,
    "data-clickid": "user_logout"
  }, /*#__PURE__*/React.createElement(common_ui.Menu_icon, {
    id: "logout",
    img_urls: get_icon_urls('logout')
  }), /*#__PURE__*/React.createElement("span", null, "Sign out"))))), sys.mobile && /*#__PURE__*/React.createElement(Store_btn, null))), (!user || user_links) && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: user_status_cls
  }, /*#__PURE__*/React.createElement("li", {
    className: "user_login"
  }, /*#__PURE__*/React.createElement("a", {
    className: "user_link",
    id: "sign_in",
    href: user_links && user_links.login || '//hola.org/signin?utm_source=holaext',
    onClick: on_login_click(),
    "data-clickid": "user_login"
  }, /*#__PURE__*/React.createElement(T, null, "Log in"))), /*#__PURE__*/React.createElement("li", {
    className: "user_signup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "user_link"
  }, /*#__PURE__*/React.createElement("a", {
    id: "sign_up",
    href: user_links && user_links.join,
    className: cn('hola_btn hola_btn--xs hola_btn--round', 'hola_btn-no_arrow hola_btn--txt_colored'),
    onClick: on_login_click(true),
    "data-clickid": "user_signup"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, null, "Get started"))), /*#__PURE__*/React.createElement("a", {
    id: "sign_up",
    className: "hola_link",
    href: user_links && user_links.join,
    onClick: on_login_click(true),
    "data-clickid": "user_signup"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, null, "Join")))))), sys.mobile && /*#__PURE__*/React.createElement(Store_btn, null)));
};
export { User_nav };